


















































import Vue from "vue";

interface DropdownOption {
  value: null | number;
  label: string;
}

export default Vue.extend({
  name: "Dropdown",

  props: {
    value: { type: Number, default: null },
    placeholder: { type: String, default: "" },
    options: {
      type: Array as () => DropdownOption[],
      required: true,
      default: [] as DropdownOption[],
    },
  },

  data() {
    return {
      selected: this.value,
      showDropdown: false,
    };
  },

  computed: {
    filteredOptions(): DropdownOption[] {
      return (this.options as DropdownOption[]).filter(
        (option) => option.value !== null
      );
    },

    selectedLabel(): string {
      const selectedOption = this.options.find(
        (option) => option.value === this.selected
      );
      return selectedOption ? selectedOption.label : this.placeholder;
    },
  },

  methods: {
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },

    hideDropdown() {
      this.showDropdown = false;
    },

    onSelect(value: number) {
      this.selected = value;
      this.hideDropdown();
      this.$emit("input", value);
    },
  },
});
